// extracted by mini-css-extract-plugin
module.exports = {"descriptionList":"DescriptionList_descriptionList__ULHMm"};